// extracted by mini-css-extract-plugin
export default {"aboutCookiesPage":"aboutCookiesPage__aboutCookiesPage--rMT0N","title":"aboutCookiesPage__title--frLer","cookieDeclaration":"aboutCookiesPage__cookieDeclaration--qUSX1"};